import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@brandwatch/axiom-components';

import BrandwatchLogo from '../../containers/BrandwatchLogo';

import './SlideChaser.css';

const enterpriseUrl = 'https://www.brandwatch.com/demo/speak-to-a-vizia-expert/';

const openLink = (href) => {
  window.open(href, '_blank', 'noopener');
};

const SlideChaser = () => {
  const onClick = useCallback(() => {
    openLink(enterpriseUrl);
  }, []);

  return (
    <div className="SlideChaser">
      <div className="SlideChaser__logo">
        <BrandwatchLogo />
      </div>
      <div className="SlideChaser__button">
        <Button variant="primary" size="medium" onClick={onClick}>
          Learn more about Vizia
        </Button>
      </div>
    </div>
  );
};

export default SlideChaser;
